import { Box, TablePagination } from "@mui/material";
import React from "react";
import { IPaginationTable } from "../../interfaces/table";
import { ROWS_PER_PAGE } from "../../utils/constants";
import SortBar from "../orders/SortBar";

const ListPagination = ({
  total,
  page,
  onChangePage,
  availableSorts,
  appliedSort,
  handleChangeFilter,
}: IPaginationTable) => (
  <Box display="flex" alignItems="center" justifyContent="flex-end" padding="8px 16px">
    <Box flex={1} maxWidth={300}>
      <SortBar
        availableSorts={availableSorts}
        appliedSort={appliedSort}
        handleChangeFilter={handleChangeFilter}
      />
    </Box>
    <TablePagination
      component="div"
      count={total || 0}
      rowsPerPage={ROWS_PER_PAGE}
      rowsPerPageOptions={[ROWS_PER_PAGE]}
      page={page || 0}
      onPageChange={(
        _event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
      ) => onChangePage(newPage)}
      showFirstButton
      showLastButton
      labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count > -1 ? count : `más de ${to}`}` }
    />
  </Box>
);

export default ListPagination;
